const getApiUrl = () => {
   let url = null;

   if (process && process.env && process.env.NODE_ENV === 'development') {
         url = 'http://localhost:5005';       
   } else {
      // Produção
      url = 'https://api-sunweb.maera.com.br';
      // Homologação
//      url = 'http://191.101.1.134:7002';
   }

   if (!url) {
      throw new Error('Url da API não foi definida.');
   }
   
   return url;
};

export const ConnectionParams = {
   apiUrl: getApiUrl(),
};